import { useEffect,useState,type ReactNode } from 'react';
import { defaultSettings,PublicSettingsContext,type PublicSettings } from './PublicSettingsContext.shared';

export const PublicSettingsProvider = ({ children }: { children: ReactNode }) => {
  const [settings, setSettings] = useState<PublicSettings>(defaultSettings);
  const [loading, setLoading] = useState(true);

  const refreshSettings = async () => {
    try {
      const response = await fetch('/api/settings/public');
      if (response.ok) {
        const data = await response.json();
        setSettings({
          infiintare_firma_enabled: data.infiintare_firma_enabled ?? true,
          extras_carte_funciara_enabled: data.extras_carte_funciara_enabled ?? true,
          asistenta_avocat_enabled: data.asistenta_avocat_enabled ?? true,
          asistenta_juridica_enabled: data.asistenta_juridica_enabled ?? true,
        });
      }
    } catch (error) {
      console.error('Error loading public settings:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    refreshSettings();
  }, []);

  return (
    <PublicSettingsContext.Provider value={{ settings, loading, refreshSettings }}>
      {children}
    </PublicSettingsContext.Provider>
  );
};
